module.exports = __webpack_public_path__ + "static/media/resources.eea1ce3b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/resources.jpeg
// module id = 406
// module chunks = 17